import m from "mithril";
import i18n from "../i18n/i18n";
const Captcha_Badge = {
    oninit: function (vnode) {
    },
    view: function (vnode) {
        return [
            m("small", { class: "grecaptcha-badge-replacement" },
                i18n.tWithNodes("recaptcha_notice", {
                    privacy_policy_link: m("a", { class: "hyperlink", target: "_blank", href: "https://policies.google.com/privacy" }, i18n.t("privacy_policy")),
                    terms_of_service_link: m("a", { class: "hyperlink", target: "_blank", href: "https://policies.google.com/terms" }, i18n.t("terms_of_service"))
                })
            )
        ];
    }
};

export default Captcha_Badge;
